import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "comments--sprite",
  "use": "comments--sprite-usage",
  "viewBox": "0 0 17 16",
  "content": "<symbol viewBox=\"0 0 17 16\" xmlns=\"http://www.w3.org/2000/svg\" id=\"comments--sprite\">\n<path d=\"M13.8333 1.3335H3.16659C2.43325 1.3335 1.83325 1.9335 1.83325 2.66683V14.6668L4.49992 12.0002H13.8333C14.5666 12.0002 15.1666 11.4002 15.1666 10.6668V2.66683C15.1666 1.9335 14.5666 1.3335 13.8333 1.3335ZM13.8333 10.6668H4.49992L3.16659 12.0002V2.66683H13.8333V10.6668Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol